import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import clsx from 'clsx';
import startCase from 'lodash/startCase';
import appStyles from '../../App.style';
import styles from './StatusField.style';

const StatusField = ({ className: classNameProp, status, index, ...other }) => {
  const className = clsx(styles.root, classNameProp, appStyles[`${status}Color`]);

  return (
    <div className={className} {...other}>
      <div className={styles.iconColumn}>
        <FontIcon
          iconName="LocationDot"
          aria-label={`${status} status`}
          id={`statusIcon${index}`}
          data-testid={`statusIcon${index}`}
        />
      </div>
      <Text className={styles.statusText} data-testid="status-text">
        {startCase(status)}
      </Text>
    </div>
  );
};

StatusField.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string.isRequired,
  index: PropTypes.number,
};

StatusField.defaultProps = {
  className: '',
  index: 0,
};

export default StatusField;
